import { Redirect } from "react-router-dom";

export const PixTransfer = () => (
  <Redirect to={{ pathname: "/pix", search: "newTransfer=true" }} />
);

export { PixTransferMockPreview } from "./PixTransferMockPreview";
export { PixTransferModal } from "./PixTransferModal";
